import { connector } from '@descomplica/microfrontend-react';
import { FC } from 'react';

import { MicrofrontendViewModel } from './Microfrontend.vm';
import { Router } from './router';

const Microfrontend: FC<{ vm: MicrofrontendViewModel }> = ({ vm }) => {
  if (vm.isLoading) {
    return <div />;
  }

  return <Router />;
};

export default connector.buildConnectedComponent(
  Microfrontend,
  MicrofrontendViewModel,
);
